import { computed, inject, Injectable } from '@angular/core';
import { ProductService, ProductDto } from '@api-client';
import { BaseStore } from '@client-libs';
import { toObservableSignal } from 'ngxtension/to-observable-signal';
import { lastValueFrom } from 'rxjs';

type State = {
  product: ProductDto | null;
  productId: string | null;
};

@Injectable({ providedIn: 'root' })
export class ProductStore extends BaseStore<State> {
  private readonly productService = inject(ProductService);

  product = toObservableSignal(computed(() => this.state()?.product));
  productId = toObservableSignal(computed(() => this.state()?.productId));

  constructor() {
    super({
      product: null,
      productId: null,
    });
  }

  setProductId(productId: string) {
    this.updateState({ productId });
    this.fetchProduct(productId);
  }

  async fetchProduct(productId?: string) {
    const id = productId || this.state()?.productId;
    if (!id) return;

    try {
      const product = await lastValueFrom(
        this.productService.productControllerFindById({ id })
      );
      this.updateState({ product });
    } catch (error) {
      console.error('Failed to fetch product:', error);
      this.updateState({ product: null });
    }
  }

  clearProduct() {
    this.updateState({ product: null, productId: null });
  }
}
